import { api } from 'services/api'

export async function updatePaymentTb(payload) {
  const { data } = await api.put('/paymentTb', payload)

  return data
}
